import { Link } from '@mui/icons-material';
import { Box } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import i18n from '../../i18n';
import { Staff } from '../../models';
import apiManage from '../../request';
import ButtonComponent from '../button/button.component';
import GlobalNotification from '../common/snackbar';
import DialogComponent from '../dialog/dialog.component';
import CommonInput from '../form/common-input.component';
import TableComponent, { HeadCell } from '../table/table.component';
// scss
import './scss/bind-account.style.scss';
import { ConditionType, SearchKeyInput, SearchKeyInputItems } from '../form/search-key-input.component';
import { PopoverEllipsis } from '../popover/popover-ellipsis';

/**
 * 绑定账号弹窗组件  员工 | 账号 | 负责人
 */
function BindAccount(props: BindAccountDialogProps) {

    const { configDialog, dialogConfigData } = props;

    // **************
    // Attributes
    // **************

    const [groupModeSelectValue, setGroupModeSelectValue] = React.useState<string>('belonged_group');
    const [list, setList] = React.useState<Staff[]>([]);
    // const [allCount, setAllCount] = React.useState(0);
    const [isTableLoading, setIsTableLoading] = React.useState(false);
    const [conditions, setConditions] = React.useState<ConditionType[]>([]);


    const selectOption = [{
        value: 'nickname',
        label: i18n.t('responsible_person_info_component_text_name'),
        type: 'TEXT'
    },
    {
        value: 'phone',
        label: i18n.t('general_text_phone'),
        type: 'TEXT'
    }];
    // 集团切换下拉框
    const groupModeOptions = [
        { value: 'belonged_group', label: i18n.t('dialog_page_bind_account_text_the_group') },
        { value: 'all_group', label: i18n.t('dialog_page_bind_account_text_all_group') }
    ]
    // 弹窗表格表头
    const headCellList: HeadCell[] = [
        {
            id: '1', label: i18n.t('responsible_person_info_component_text_name'),
            renderFunction: (row: Staff) => {
                return <>{row.first_name} {row.last_name}</>
            }
        },
        { id: 'email', label: i18n.t('general_text_email') },
        {
            id: 'phone', label: i18n.t('general_text_phone'),
            renderFunction: (row: any,) => {
                return `${row.phone_prefix || ''} ${row.phone || ''}`
            }
        },
        {
            id: 'belonged_group_nickname', label: dialogConfigData?.type === 'RESTAURANT' ? i18n.t('general_text_belonged_group') : '',
            renderFunction: (row: any,) => {
                return dialogConfigData?.type === 'RESTAURANT' ? `${row?.belonged_group?.[0]?.nickname || ''}` : null
            }
        },
        {
            id: 'belonged_group', label: dialogConfigData?.type === 'RESTAURANT' ? i18n.t('group_management_page_text_group_identification_code') : '',
            renderFunction: (row: any,) => {
                return dialogConfigData?.type === 'RESTAURANT' ? `${row?.belonged_group?.[0]?.string_id || ''}` : null
            }
        },
        {
            id: '4', label: i18n.t('restaurant_info_page_table_text_associated_restaurant'),
            renderFunction: (row: Staff) => {
                const bindRestaurantStr = row.belonged_restaurant?.map(item => { return item?.nickname }).join('，') || '';
                return (
                    bindRestaurantStr.length > 30 ?
                        <>
                            <PopoverEllipsis showData={bindRestaurantStr} />
                        </>
                        :
                        <>{bindRestaurantStr}</>
                )
            }
        },
        {
            id: '5', label: i18n.t('bind_account_component_text_bind'),
            renderFunction: (row: Staff) => {
                return renderFeaturesByDialog(row);
            }
        }
    ]


    // 弹窗功能键
    const renderFeaturesByDialog = (row: Staff) => {
        const responsible_group = row?.responsible_group?.map(item => { return item?.string_id }) || [];
        // 当前弹窗目标集团 string_id（用于集团绑定状态判断）
        const currentGroupStringId = props.dialogConfigData?.groupStringId || '';
        let isBind: boolean = false;

        if (props.dialogConfigData?.type === 'GROUP') {
            isBind = responsible_group.includes(currentGroupStringId);
        } else if (props.dialogConfigData?.type === 'RESTAURANT') {
            // 绑定的餐厅stringId数组
            const responsibleRestaurantStringID: string[] = []
            if (row.belonged_restaurant) {
                row.belonged_restaurant.forEach((item) => {
                    responsibleRestaurantStringID.push(item?.string_id || '')
                })
            }
            isBind = _.includes(responsibleRestaurantStringID, props.dialogConfigData?.restaurantStringId)
        }
        return (
            <>
                <ButtonComponent
                    variant='text'
                    sx={(theme) => { return { color: isBind ? theme.palette.primary.main : theme.palette.secondary.main } }}
                    handleClick={async () => {
                        if (props.dialogConfigData?.type === 'GROUP') {
                            await handleBindAccountGroup(row);
                        } else if (props.dialogConfigData?.type === 'RESTAURANT') {
                            await handleBindAccountRestaurant(row);
                        }
                        getStaffConditionByDialog(groupModeSelectValue);
                    }}
                >
                    <Link />
                </ButtonComponent>
            </>
        )
    }

    // **************
    // Function
    // **************

    React.useEffect(() => {
        if (props.configDialog.visible) {
            init();
        }
        return () => { }
    }, [props.configDialog.visible])

    const init = async () => {
        if (dialogConfigData?.type === 'RESTAURANT') {
            await getStaffConditionByDialog('belonged_group');
        } else {
            await getStaffConditionByDialog();
        }
    }

    // 获取负责人绑定信息数据
    const getStaffConditionByDialog = async (selectVal: string = 'belonged_group') => {
        // 开启表格加载
        setIsTableLoading(true);


        const extraParams = {};
        conditions.forEach((item) => {
            extraParams[item.key] = extraParams[item.key] ? _.concat(extraParams[item.key], item.value) : [item.value];
        })

        const params = {
            belonged_group: dialogConfigData?.groupStringId || '',
            is_belonged_group: (selectVal === 'belonged_group') ? true : false,
            pagination_per_page: 999,
            pagination_page: 1,
            ...extraParams,
        }
        const result = await apiManage.get_staff_condition(params);
        if (!result?.error) {
            const { dbResults } = result[0];
            setList(dbResults || []);
            // setAllCount(totalCount?.[0]?.count || 0);
        } else {
            GlobalNotification.error(`${i18n.t('bind_account_component_failed_group_employees')}`)
        }
        // 关闭表格加载
        setIsTableLoading(false);
    }
    /**
     * 集团场景：绑定/解绑负责人与当前弹窗目标集团的关系。
     * 与列表「绑定」图标一致：以 responsible_group 是否包含弹窗 groupStringId 判定已绑定；
     * 未包含则调 ADD，已包含则调 REMOVE（不可再用员工 belonged_group 与 responsible_group 比对，否则与弹窗目标不一致）。
     */
    const handleBindAccountGroup = async (row: Staff) => {
        setIsTableLoading(true);
        // 负责人已负责的集团 string_id 列表
        const responsible_group = row?.responsible_group?.map(item => { return item?.string_id }) || [];
        // 当前弹窗要操作的目标集团 string_id
        const targetGroupStringId = props.dialogConfigData?.groupStringId || '';
        // 是否已对目标集团绑定（与 renderFeaturesByDialog 中 isBind 含义一致）
        const isBoundToTargetGroup = responsible_group.includes(targetGroupStringId);
        // true：执行绑定；false：执行解绑
        const shouldAddBinding = !isBoundToTargetGroup;
        const params = {
            _id: row?._id || '',
            type: 'GROUP',
            responsible_group: targetGroupStringId,
            option: shouldAddBinding ? 'ADD' : 'REMOVE'
        }
        // 请求数据
        const result = await apiManage.patch_staff_id_id_responsible(params);
        if (!result?.error) {
            // 成功提示
            GlobalNotification.success(`${i18n.t(shouldAddBinding ?
                'bind_account_component_message_success_bind_group' :
                'responsible_person_info_component_message_successfully_untie_group_leader'
            )}`);
        } else {
            // 错误提示
            GlobalNotification.error(`${i18n.t(shouldAddBinding ?
                'bind_account_component_message_fail_bind_group' :
                'responsible_person_info_component_message_fail_untie_group_leader'
            )}`);
        }
        await props.dialogConfigData?.bindCallBack();

    }

    // $ 餐厅 解绑\绑定账号
    async function handleBindAccountRestaurant(row: Staff) {
        setIsTableLoading(true);
        // 绑定的餐厅stringId数组
        const responsibleRestaurantStringID: string[] = []
        if (row.belonged_restaurant) {
            row.belonged_restaurant.forEach((item) => {
                responsibleRestaurantStringID.push(item?.string_id || '')
            })
        }
        // 是否已绑定当前餐厅
        const isBind = !(_.includes(responsibleRestaurantStringID, props.dialogConfigData?.restaurantStringId))
        const params = {
            _id: row?._id || '',
            belonged_restaurant: [props.dialogConfigData?.restaurantStringId],
            type: isBind ? 'ADD' : 'REMOVE'
        }
        const result = await apiManage.patch_staff_id_belonged_restaurant(params);
        if (!result?.error) {
            // 成功提示
            GlobalNotification.success(`${i18n.t(isBind ?
                'restaurant_page_request_text_associated_restaurant_success' :
                'restaurant_page_request_text_untie_restaurant_association_successfully'
            )}`);
        } else {
            // 错误提示
            GlobalNotification.error(`${i18n.t(isBind ?
                'restaurant_page_request_text_failed_associate_restaurant' :
                'restaurant_page_request_text_failed_unbind_restaurant_association'
            )}`);
        }
        await props.dialogConfigData?.bindCallBack();
    }

    return (
        <DialogComponent
            open={configDialog.visible ?? false}
            maxWidth={'lg'}
            heightSize={'large'}
            defaultHeaderProps={{
                title: configDialog?.title || i18n.t('bind_account_component_bind_new_account'),
            }}
            onClose={() => {
                setGroupModeSelectValue('belonged_group');
                configDialog?.onClose?.()
            }}
        >
            <Box className={'bind-account-container'}>
                <Box className={'bind-account-search-tool'} flexDirection='row' justifyContent={'space-between'}>
                    <SearchKeyInput
                        items={selectOption as SearchKeyInputItems[]}
                        conditions={conditions}
                        onSearch={(conditions: ConditionType[]) => {
                            setConditions(conditions);
                            getStaffConditionByDialog(groupModeSelectValue);
                        }}
                        showConditionsBox
                    />
                    {/* 集团模式筛选  下拉框 */}
                    {
                        // 集团和餐厅 都需要绑定负责人显示此下拉 (本集团/其他集团)
                        <Box className={'bind-account-select-input'}>
                            <CommonInput
                                inputType={'SELECT'}
                                items={groupModeOptions}
                                size={'small'}
                                fullWidth
                                value={groupModeSelectValue}
                                onChange={(e) => {
                                    const selectVal = e.target.value;
                                    setGroupModeSelectValue(selectVal);
                                    getStaffConditionByDialog(selectVal);
                                }}
                            />
                        </Box>
                    }
                </Box>
                <TableComponent
                    {...{
                        showChecked: 0,
                        list,
                        headCellList,
                        isTableLoading,
                        isPagination: true,
                        isUseCustomPagination: true,
                        allCount: list.length,
                    }}
                />
            </Box>
        </DialogComponent>
    )

}

export default BindAccount;

export type BindAccountDialogProps = {
    // 打开弹窗配置
    configDialog: {
        // 弹窗打开
        visible: boolean;
        // 弹窗标题
        title: string;
        // 关闭弹窗
        onClose?: () => void;
    };

    // 弹窗内的数据
    dialogConfigData?: {
        type: 'GROUP' | 'RESTAURANT',
        restaurantStringId: string;
        groupStringId: string;
        bindCallBack: () => Promise<void>;
    };
}